import { Dialog, Separator, Skeleton, SkeletonText } from '~/components';
import { clsx } from '~/styles/utils';

import {
  bodyStyle,
  contentStyle,
  headerStyle,
  profilePictureStyle,
  skeletonHeaderStyle,
  skeletonProfilePictureStyle,
  textWrapperStyle,
} from './CommunityProfileDialog.css';

export const CommunityProfileDialogSkeleton = () => {
  return (
    <Dialog.Body className={bodyStyle}>
      <Dialog.Header className={headerStyle}>
        <Skeleton className={skeletonHeaderStyle}>
          <div className={clsx(profilePictureStyle, skeletonProfilePictureStyle)} />

          <div className={textWrapperStyle}>
            <SkeletonText lineHeight="tight" width="70%" />

            <SkeletonText lineHeight="tight" width="50%" />
          </div>
        </Skeleton>
      </Dialog.Header>

      <Skeleton className={contentStyle}>
        <div>
          <SkeletonText fontSize="small" />

          <SkeletonText fontSize="small" />

          <SkeletonText fontSize="small" />
        </div>

        <Separator />
      </Skeleton>
    </Dialog.Body>
  );
};
